import { BrutalCard } from "@/components/ui/BrutalCard";
import { Share2, PenTool } from "lucide-react";
import { useTranslation } from "react-i18next";

interface SubmissionTypeSelectorProps {
  onSelectType: (type: 'social' | 'blog') => void;
}

export const SubmissionTypeSelector = ({ onSelectType }: SubmissionTypeSelectorProps) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <h2 className="font-heading text-2xl mb-4">{t("creator.selectType")}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <BrutalCard 
          className="cursor-pointer hover:scale-[1.02] transition-transform p-8 text-center"
          onClick={() => onSelectType('social')}
        >
          <div className="flex flex-col items-center gap-4">
            <div className="w-20 h-20 bg-primary border-[3px] border-dark flex items-center justify-center shadow-[4px_4px_0px_0px] shadow-dark">
              <Share2 className="w-10 h-10 text-primary-foreground" strokeWidth={2.5} />
            </div>
            <h3 className="font-heading text-xl">{t("creator.socialButton")}</h3>
            <p className="text-sm text-muted-foreground">
              {t("creator.socialButtonDesc")}
            </p>
            <div className="flex gap-2 mt-2">
              <span className="text-2xl">📱</span>
              <span className="text-2xl">💼</span>
              <span className="text-2xl">📸</span>
              <span className="text-2xl">🎵</span>
              <span className="text-2xl">▶️</span>
            </div>
          </div>
        </BrutalCard>

        <BrutalCard 
          className="cursor-pointer hover:scale-[1.02] transition-transform p-8 text-center"
          onClick={() => onSelectType('blog')}
        >
          <div className="flex flex-col items-center gap-4">
            <div className="w-20 h-20 bg-secondary border-[3px] border-dark flex items-center justify-center shadow-[4px_4px_0px_0px] shadow-dark">
              <PenTool className="w-10 h-10 text-secondary-foreground" strokeWidth={2.5} />
            </div>
            <h3 className="font-heading text-xl">{t("creator.blogButton")}</h3>
            <p className="text-sm text-muted-foreground">
              {t("creator.blogButtonDesc")}
            </p>
            <div className="flex gap-2 mt-2">
              <span className="text-2xl">✍️</span>
              <span className="text-2xl">📝</span>
              <span className="text-2xl">📄</span>
            </div>
          </div>
        </BrutalCard>
      </div>
    </div>
  );
};
